import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { BROKER } from "@/lib/constants";
import { Award, Users, Calendar, Mail } from "lucide-react";

export default function AboutDarryl() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 sm:py-32 bg-pp-cream relative"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="rounded-3xl overflow-hidden aspect-square shadow-[0_24px_60px_rgba(26,46,38,0.18)]">
                <img
                  src={BROKER.photo}
                  alt={`${BROKER.name} - Life Insurance Broker`}
                  className="w-full h-full object-cover"
                  data-testid="broker-photo"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-pp-forest text-pp-bone rounded-2xl p-6 max-w-[220px] shadow-lg">
                <div className="font-sans font-semibold text-3xl leading-none tracking-tight">12+</div>
                <div className="text-xs uppercase tracking-wider mt-2 opacity-80">
                  Years guiding families
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-pp-forest">
              Meet your broker
            </span>
            <h2 className="mt-4 font-serif font-medium text-4xl sm:text-5xl lg:text-6xl tracking-tight text-pp-forest-deep leading-[1.05]">
              I'm Darryl Kelly, and I'll{" "}
              <span className="italic text-pp-terracotta">walk with you.</span>
            </h2>
            <p className="mt-6 text-lg text-pp-text-secondary leading-relaxed">
              Life insurance shouldn't feel like a sales call. I founded Policy
              Provisions to give families honest guidance—comparing top-rated
              carriers and translating the fine print into plain English so you
              can make the right call for the people you love.
            </p>

            <div className="mt-10 grid sm:grid-cols-2 gap-5">
              {[
                { Icon: Award, label: "Licensed independent broker" },
                { Icon: Users, label: "Hundreds of families protected" },
                { Icon: Calendar, label: "Same-day consultations" },
                { Icon: Mail, label: "Personal, no-pressure service" },
              ].map(({ Icon, label }) => (
                <div
                  key={label}
                  className="flex items-center gap-4 bg-white rounded-xl px-5 py-4 border border-pp-border-subtle"
                >
                  <Icon className="w-5 h-5 text-pp-forest stroke-[1.5]" />
                  <span className="text-sm text-pp-forest-deep">{label}</span>
                </div>
              ))}
            </div>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <a
                href={BROKER.calendarUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  data-testid="about-book-btn"
                  className="bg-pp-forest hover:bg-pp-forest-dark text-white rounded-full px-8 py-6"
                >
                  Book a call with Darryl
                </Button>
              </a>
              <Link to="/quote">
                <Button
                  data-testid="about-quote-btn"
                  variant="outline"
                  className="border-pp-forest text-pp-forest hover:bg-pp-forest hover:text-white rounded-full px-8 py-6 bg-transparent"
                >
                  Start my quote
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
